import { prop } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';
import { setGamesFavorites } from 'js/hooks/games/store/actions';

export const useResetFavoriteGames = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect(() => {
        if (!isLoggedIn) {
            dispatch(setGamesFavorites([]));
        }
    }, [isLoggedIn, dispatch]);
};
